'use strict';

var angularModule = angular.module('t2g.common.data-access.payment', []);

module.exports = angularModule;

angularModule.factory('PaymentResource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/v2/payment/:action/:subaction';

  var resource = $resource(
    resourceUrl,
    {},
    {
      getAll: { method: 'GET', isArray: false, params: {} },
      getClientToken: { method: 'GET', isArray: false, params: { action: 'clientToken' } },
      transactionSale: { method: 'POST', params: { action: 'transaction', subaction: 'sale' } },
    },
  );

  return resource;
});

angularModule.factory('PaymentDA', function($q, settings, UserSession, PaymentResource) {
  var officeId = UserSession.getOffice();

  return {
    getClientToken: function() {
      return PaymentResource.getClientToken().$promise;
    },
    transactionSale: function(data) {
      return PaymentResource.transactionSale(data).$promise;
    },
    getAll: function() {
      return PaymentResource.getAll({ action: officeId }).$promise;
    },
    getInvoiceFilePath: function(paymentId) {
      return settings.invoiceFolder + officeId + '/' + paymentId;
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/payment.js